import { createSlice } from "@reduxjs/toolkit";

export const LoanApplicationSlice = createSlice({
  name: "loanApplication",
  initialState: {
    aadharTranaction: {},
    // transactionId: null,
    // loanApplicationId: "",
    // loanApplicationNumber: "",
    aadharDetails: {},
    selfieDetails: {},
  },
  reducers: {
    saveAadharTransaction: (state, action) => {
      state.aadharTranaction = {...action.payload};
    },
    // saveTransactionId: (state, action) => {
    //   state.transactionId = action.payload;
    // },
    // saveLoanApplicationId: (state, action) => {
    //     state.loanApplicationId = action.payload;
    // },
    // saveLoanApplicationNumber: (state, action) => {
    //     state.loanApplicationNumber = action.payload;
    // },
    saveAadharDetails: (state, action) => {
      state.aadharDetails = action.payload;
    },
    saveSelfieDetails: (state, action) => {
      state.selfieDetails = action.payload;
    },
    clearAllData: (state, action) => {
      state.aadharDetails = {};
      state.aadharTranaction = {};
      // state.transactionId = "";
      // state.loanApplicationId = "";
      // state.loanApplicationNumber = "";
    },
  },
});

export const { saveAadharTransaction, saveAadharDetails, clearAllData, saveSelfieDetails } = LoanApplicationSlice.actions;

export default LoanApplicationSlice.reducer;
